export const MenuIdTypes = {
  LIVE_BOOKING: "live-booking",
  LIVE_SERVICES: "live-services",
  LIVE_FEEDBACK: "feedback",
};
